import axios from "axios";
import * as API_LINKS from '../../../configurations/links.jsx'
import {toast} from 'react-toastify';
import cookie from 'react-cookies'

export const FETCH_GET_SATUAN_PAGE = 'FETCH_GET_SATUAN_PAGE'
export const RECEIVE_GET_SATUAN_PAGE = 'RECEIVE__GET_SATUAN_PAGE'
export const FAILED_GET_SATUAN_PAGE = 'FAILED_GET_SATUAN_PAGE'


export function fetchGetSatuanPage(_data){
    
    return (dispatch, getState) => {
        dispatch({type: FETCH_GET_SATUAN_PAGE});
        axios({
            method: 'post',
            url: API_LINKS.DIVISION_GET_PAGE,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
             if(response.status === 200) {
                if(response.data.status === "success") {
                    dispatch( {
                        type: RECEIVE_GET_SATUAN_PAGE,
                        payload: response.data.result
                    })
                   
                } else {
                    dispatch({
                        type: FAILED_GET_SATUAN_PAGE
                    })
                    return toast.error(response.data.message);
                }
            } else {
                dispatch({
                    type: FAILED_GET_SATUAN_PAGE
                })
                return toast.error(response.data.message);
            }
        })
        .catch(function(error){
            if (error.response){
                dispatch({
                    type: FAILED_GET_SATUAN_PAGE
                })
                return toast.error(error.response.data.message);;
            }
        })
        }
    }



// WEBPACK FOOTER //
// ./src/redux/actions/satuan/aSatuan-GetPageSatuan.jsx